<template>
  <div class="preloader-area" id="preloader" v-if="isLoading">
    <div class="loader">
      <div class="waviy">
        <span>G</span>
        <span>U</span>
        <span>A</span>
        <span>C</span>
        <span>|</span>
        <span>N</span>
        <span>|</span>
        <span>G</span>
        <span>r</span>
        <span>i</span>
        <span>l</span>
        <span>l</span>
      </div>
      <div class="tagline">
        <span>H</span>
        <span>a</span>
        <span>l</span>
        <span>a</span>
        <span>l</span>
        <span>&nbsp;</span>
        <span>M</span>
        <span>e</span>
        <span>x</span>
        <span>i</span>
        <span>c</span>
        <span>a</span>
        <span>n</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PreLoader",
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  },
});
</script>

<style lang="scss">
.preloader-area {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  position: fixed;
  text-align: center;
  background-color: rgb(0, 24, 29);
  overflow-x: hidden;
}
.preloader-area .loader {
  transform: translateY(-50%);
  position: absolute;
  right: 0;
  top: 50%;
  left: 0;
}
.preloader-area .waviy {
  margin-top: 20px;
  position: relative;
  text-align: center;
  font-size: 50px;
  font-weight: 700;
}
.preloader-area .tagline {
  margin-top: 10px;
  position: relative;
  text-align: center;
  font-size: 24px;
  font-weight: 500;
}
.preloader-area .waviy span {
  position: relative;
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
  display: inline-block;
  color: var(--secondaryColor);
  -webkit-animation: waviy 1s infinite;
  animation: waviy 1s infinite;
}
.preloader-area .tagline span {
  position: relative;
  display: inline-block;
  color: var(--optionalColor);
}
.preloader-area .waviy span:nth-child(2) {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.preloader-area .waviy span:nth-child(3) {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.preloader-area .waviy span:nth-child(4) {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.preloader-area .waviy span:nth-child(5) {
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.preloader-area .waviy span:nth-child(1),
.preloader-area .waviy span:nth-child(2),
.preloader-area .waviy span:nth-child(3),
.preloader-area .waviy span:nth-child(4),
.preloader-area .waviy span:nth-child(8),
.preloader-area .waviy span:nth-child(9),
.preloader-area .waviy span:nth-child(10),
.preloader-area .waviy span:nth-child(11),
.preloader-area .waviy span:nth-child(12) {
  color: var(--whiteColor) !important;
}
.preloader-area .waviy span:nth-child(5),
.preloader-area .waviy span:nth-child(6),
.preloader-area .waviy span:nth-child(7) {
  color: var(--primaryColor) !important;
}
.preloader-area .waviy span:nth-child(6) {
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
}
.preloader-area .waviy span:nth-child(7) {
  -webkit-animation-delay: 0.7s;
  animation-delay: 0.7s;
}
.preloader-area .waviy span:nth-child(8) {
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
.preloader-area .waviy span:nth-child(9) {
  -webkit-animation-delay: 0.9s;
  animation-delay: 0.9s;
}
.preloader-area .waviy span:nth-child(10) {
  -webkit-animation-delay: 1.0s;
  animation-delay: 1.0s;
}
.preloader-area .waviy span:nth-child(11) {
  -webkit-animation-delay: 1.1s;
  animation-delay: 1.1s;
}
.preloader-area .waviy span:nth-child(12) {
  -webkit-animation-delay: 1.2s;
  animation-delay: 1.2s;
}
@-webkit-keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}
@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}
</style>